<template>
  <div>
    <div v-if="!fileGiven" :class="animate ? 'flip-vertical-right' : ''">
      <Upload
        type="drag"
        action="//jsonplaceholder.typicode.com/posts/"
        :before-upload="handleBeforeUpload"
        :format="['pfx']"
      >
        <div style="padding: 20px 0; height:150px">
          <div class="text-icon">
            <div v-if="file == null" :class="fileWrongType ? 'error' : ''">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"/>
              <p class="box-text">{{ uploadBoxText }}</p>
            </div>

            <div v-if="file !== null" class="file">
              <Icon type="ios-document-outline" size="52" style="color: #3399ff"/>
              <p class="box-text">{{ file.name }}</p>
            </div>
            <p v-if="certificadoCnpjInvalido" class="error" style="color: red;">
              {{ mensagemCnpjInvalido }}
            </p>
          </div>
        </div>
      </Upload>
    </div>

    <div
      v-if="fileGiven && !hasPassword"
      class="password-box flip-vertical-left"
    >
      <div v-if="file !== null">Arquivo: {{ file.name }}</div>
      <p v-if="certificadoCnpjInvalido" class="error" style="color: red;">
        {{ mensagemCnpjInvalido }}
      </p>


      <p>Senha do certificado digital</p>
      <div>
        <Input
          id="pwd-input"
          @on-change="handlePassword"
          v-model="password"
          prefix="ios-key"
        />
        <p v-if="inputError" class="error">{{ inputMessage }}</p>
      </div>
    </div>

    <!-- loading-->
    <div v-if="fileUploading" class="loading">
      <Spin fix>
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"/>
        <div>Enviando certificado</div>
      </Spin>
    </div>

    <div v-if="finishing">
      <div v-if="uploadSuccess" class="success">
        <h4 class="info-success-certificate">Certificado atualizado com sucesso</h4>
      </div>
      <div v-if="uploadError" class="error">
        <p>{{ errorMessage }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: "UploadCertificado",
  props: {
    id_empresa: Number
  },
  data() {
    return {
      file: null,
      password: null,
      uploadBoxText: "Clique para buscar ou arraste aqui o arquivo para upload",
      fileWrongType: false,
      loadingStatus: false,
      fileGiven: false,
      hasPassword: false,
      inputError: false,
      errorMessage: 'Erro na requisição!',
      animate: false,
      inputMessage: '',
      fileUploading: false,
      uploadSuccess: false,
      uploadError: false,
      finishing: false,
      certificadoCnpjInvalido: false,
      mensagemCnpjInvalido: '',
    };
  },
  methods: {
    handleBeforeUpload(file) {
      this.file = file;
      this.certificadoCnpjInvalido = false;

      if (this.file.type === "application/x-pkcs12") {
        setTimeout(() => {
          this.animate = true;
          setTimeout(() => {
            this.fileGiven = true;
          }, 500);
        }, 1000);
      } else {
        this.file = null;
        this.fileWrongType = true;
        this.uploadBoxText = "Tipo do arquivo invalido! Selecione um arquivo.pfx";
      }

      return false;
    },
    handlePassword: _.debounce(function () {
      if (this.password !== '') {
        if (this.password.split('').filter((el) => el !== ' ').length < 4) {
          this.inputError = true;
          this.inputMessage = 'A senha deve ter no mínimo 4 dígitos!';
        } else {
          this.hasPassword = true;
          this.uploadFile();
        }
      }
    }, 2000),
    async uploadFile() {

      if (!this.file) {
        this.resetUpload('Nenhum arquivo selecionado!', true);        
        return;
      }
  
      if (!this.password) {
        this.resetUpload('Senha obrigatória!', true);
        return;
      }
  
      // Pega o id e email do usuário na sessão
      const user = JSON.parse(localStorage.getItem('user'))
      const byPass = user && (user.id_pessoa === 7329 || user.email === 'phkarnikowski@bitis.com.br')

      // Só vou validar o certificado se não for o Pablo
      if (!byPass) {

        // Verifica se o CNPJ do certificado bate com o da empresa
        const sameCnpj = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = async (event) => {
            try {
              const base64 = btoa(
                new Uint8Array(event.target.result)
                  .reduce((data, byte) => data + String.fromCharCode(byte), '')
              );
    
              const response = await this.$axios.post(
                'fiscal/certificado/check-cnpj',
                {
                  certificado: base64,
                  senha: this.password,
                  id_empresa: this.id_empresa
                }
              );
    
              resolve(response.data.same_cnpj ? response.data.same_cnpj : false); 
            } catch (err) {
              // Houve algum erro, mas por pedido de pessoas acima de mim, permitirei que o certificado seja inserido
              console.error(err)
              resolve(true);
            }
          };

          reader.onerror = () => reject("Erro ao ler o certificado");
          reader.readAsArrayBuffer(this.file);
        });

        if (!sameCnpj) {
          this.resetUpload('O CNPJ do certificado não corresponde ao CNPJ da empresa cadastrada.', true);
          return;
        }
      }

      //mostra o loading na tela
      this.fileUploading = true;

      const form = new FormData();
      form.append('id_empresa', this.id_empresa);
      form.append('file', this.file);
      form.append('password', this.password);

      this.$axios.post('clientes/certificate', form)
        .then(({data}) => {
          //retira o loading
          this.fileUploading = false;

          if (data.codigo === 1) {
            this.finishing = true;
            this.uploadSuccess = true;
          } else {
            this.inputError = true;
            this.inputMessage = data.mensagem;
            this.hasPassword = false
            this.finishing = false;
            this.password = null;
          }
        })
        .catch(err => {
          //exibe a tela de erro.
          this.finishing = true;
          this.fileUploading = false;
          this.uploadError = true;
          this.errorMessage = "Erro ao fazer upload: " + err;
        })
    },
    resetUpload(message, invalid) {
        this.certificadoCnpjInvalido = invalid;
        this.mensagemCnpjInvalido = message;
        this.file = null;
        this.password = null;
        this.fileGiven = false;
        this.hasPassword = false;
        this.inputError = false;
        this.animate = false;
    }
  }
};
</script>

<style scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

